import PathwayStepDetailsContainer from './pathway_step_details_container';

const PathwayStepDetails = PathwayStepDetailsContainer;
export default PathwayStepDetails;
